import { render, staticRenderFns } from "./ProjectsIntro.vue?vue&type=template&id=46a68b65&"
import script from "./ProjectsIntro.vue?vue&type=script&lang=js&"
export * from "./ProjectsIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports